import PresentationVideoChartComponent from "./PresentationVideoChartComponent";

export default PresentationVideoChartComponent;